namespace $.$$ {

	export class $shm_hitalama_teams_maps extends $.$shm_hitalama_teams_maps {

		team() {
			return this.$.$shm_hitalama_app.Root( 0 ).team_current()!
		}

		list() {
			return this.team().maps_list( null )!
		}

		@ $mol_action
		team_add( next?: Event ) {
			if( next === undefined ) return null
			this.add_map( 'private' )
			return next
		}

		@ $mol_action
		add_map( _access_level: keyof ReturnType< typeof $shm_hitalama_map.access_level_to_ranks > ) {
			const list = this.list()
			const titles = list.remote_list().map( map => map.title() )
			const title = $shm_hitalama_inc_name( titles, this.title_default() )
			const map = $shm_hitalama_map.make_in_land( list.land().area_make(), title, 'team' )
			this.team().map_rank_all( map )
			list.add( map.link() )
			this.spread( map.link().str )
			return map
		}

	}

}
